import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import SmoothScroll from "./components/SmoothScroll";
import FooterPage from "./components/FooterPage";
import WhatsAppWidget from "./components/WhatsAppWidget";
import ScrollToTop from "./components/ScrollToTop"; // ✅ Add this import

// Pages
import Chemical from "./pages/Chemical";
import Equipment from "./pages/Equipment";

// Sections for Home Page
import Hero from "./components/Hero";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedProducts from "./components/FeaturedProducts";
import WhyChooseUs from "./components/WhyChooseUs";

// Lazy loaded pages
const About = lazy(() => import("./pages/About"));
const Products = lazy(() => import("./pages/Products"));
const Contact = lazy(() => import("./pages/Contact"));
const Faqs = lazy(() => import("./pages/Faqs"));

// Home page
const Home = () => (
  <>
    <Hero />
    <CategoriesSection />
    <FeaturedProducts />
    <WhyChooseUs />
  </>
);

function App() {
  return (
    <div className="App font-sans">
      <Router>
        <ScrollToTop /> {/* ✅ Add this line just after Router */}

        {/* Smooth scrolling and navbar */}
        <SmoothScroll />
        <Navbar />

        {/* Routes with Suspense for lazy-loaded pages */}
        <Suspense fallback={<div className="text-center py-20">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/chemicals" element={<Chemical />} />
            <Route path="/products/equipment" element={<Equipment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<Faqs />} />
          </Routes>
        </Suspense>

        {/* Footer */}
        <FooterPage />

        {/* Floating WhatsApp widget */}
        <WhatsAppWidget />
        <ScrollToTop />
      </Router>
    </div>
  );
}

export default App;
